import React from 'react';

import { Button } from '../../../components/MuiGenerals';
import { useTranslation } from '../../../hooks';

interface IProps {
  onClick: () => void;
  isDisabled?: boolean;
  btnText?: string;
}

const ApproveButton = ({ onClick, isDisabled, btnText }: IProps) => {
  const { tc } = useTranslation();

  return (
    <Button
      className={'inheritColor'}
      color={'primary'}
      variant={'contained'}
      children={btnText || tc('submit')}
      onClick={onClick}
      style={{
        width: '160px',
        height: '38px',
        marginRight: '12px',
        backgroundColor: isDisabled ? '#3a3a3a' : '#5183FF',
        color: isDisabled ? '#888888' : '#FFFFFF',
        borderRadius: '8px',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.6 : 1,
      }}
      disabled={isDisabled}
    />
  );
};

export default ApproveButton;
